<template>

  <div>
    <Head title="Prüfungssimulation"/>

    <div class="exam">

      <div class="exam--runnning">

        <question-index :questions="filteredQuestions.length" :current="index + 1"/>

        <questions v-if="index != null"
                   :type="'practice'"
                   :questions="filteredQuestions"
                   :index="index"
                   :is-first-question="isFirstQuestion"
                   @indexChanged="updateIndex"
                   @selfcheck="startSelfcontrol"
                   @finished="questionsFinished"
        ></questions>

        <div v-if="filteredQuestions.length === 0" class="justify-center mb-5 lg:flex items-center gap-5">
          <div class="card column max-w-[1440px]">
            <h3 class="text-lg md:text-xl text-secondary-500 font-bold my-2">Du hast alle Fragen in diesem Thema einmal durchgearbeitet. Gut gemacht!</h3>
            <p>Wenn du sie noch einmal wiederholen möchtest, entferne einfach das Häkchen bei <b>'Nur neue Fragen üben'</b> in der <a class="underline" href="#" onclick="history.back()">Themenübersicht</a>. Hier ist ein Screenshot, wo das zu finden ist:</p>
            <div class="mb-4 mt-6 hidden lg:block">
              <img src="/img/exam/not-practiced-questions.png" alt="nicht geübte Fragen" class="mx-auto">
            </div>
            <div class="mb-4 mt-6 lg:hidden">
              <img src="/img/exam/not-practiced-questions-mobile.png" alt="nicht geübte Fragen" class="">
            </div>
          </div>
        </div>

        <div v-if="results" class="">
          <practice-results :questions="filteredQuestions"></practice-results>
        </div>
      </div>
    </div>

  </div>


</template>

<script>
import {Head} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import PracticeResults from '../../Shared/Mistakes/PracticeResults'

export default {

  components: {
    Head,
    PracticeResults,
  },

  layout: Layout,

  props: {
    category: Object,
    questions: Array,
  },

  data() {
    return {
      index: 0,
      currentStep: 'questions',
      isFirstQuestion: true,
      showSelfcontrol: false,
      hasResults: false,
      results: null,
      startIndex: 0,
      /**
       * Free Control Data is data that has to be controlled by the user
       * it only comes back if the test has some free text questions
       */
      freeControlData: [],
    }
  },

  computed: {
    filteredQuestions: function () {
      let questions = []
      this.questions.map(question => {
        // add property
        question.isCorrect = null
        question.answers = []
        questions.push(question)
      })
      return questions
    },
  },

  methods: {
    questionsFinished(results) {
      this.results = results
    },

    updateIndex(value) {
      this.index = value
    },

    startSelfcontrol(response) {
      if (response && response.freetext_data) {
        this.freeControlData = response.freetext_data
      }
      this.showSelfcontrol = true
    },
  },
}
</script>

<style scoped>

</style>